export const CardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="130"
    height="96"
    viewBox="0 0 130 96"
    fill="none"
  >
    <path
      d="M28.3813 8C29.5798 8 30.7291 7.57857 31.5766 6.82843C32.424 6.07828 32.9001 5.06087 32.9001 4C32.9001 2.93913 32.424 1.92172 31.5766 1.17157C30.7291 0.421427 29.5798 0 28.3813 0V8ZM53.1499 0C51.9514 0 50.8021 0.421427 49.9547 1.17157C49.1073 1.92172 48.6312 2.93913 48.6312 4C48.6312 5.06087 49.1073 6.07828 49.9547 6.82843C50.8021 7.57857 51.9514 8 53.1499 8V0ZM102.018 8C112.321 8 120.93 15.68 120.93 25.44H129.968C129.968 11.52 117.593 0 102.018 0V8ZM28.3813 0C12.8069 0 0.437666 11.52 0.437666 25.44H9.47508C9.47508 15.68 18.0787 8 28.3813 8V0ZM120.93 25.44C120.93 34.3307 113.761 41.5253 104.705 42.7093L106.031 50.624C119.677 48.8373 129.968 38.1547 129.968 25.44H120.93ZM25.6942 42.7093C16.6327 41.5253 9.47508 34.336 9.47508 25.44H0.431641C0.431641 38.1547 10.7222 48.8373 24.3748 50.624L25.6942 42.7093ZM53.1499 8H102.018V0H53.1499V8Z"
      fill="url(#paint0_linear_1501_284)"
    />
    <path
      d="M65.2001 62.668V36.0013M65.2001 36.0013L53.1502 48.444M65.2001 36.0013L77.25 48.444"
      stroke="url(#paint1_linear_1501_284)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.0254 41.3333C23.0254 31.2747 23.0254 26.2507 26.556 23.1253C30.0866 20 35.7621 20 47.1252 20H83.2748C94.6379 20 100.313 20 103.844 23.1253C107.375 26.2507 107.375 31.2747 107.375 41.3333V73.3333C107.375 83.392 107.375 88.416 103.844 91.5413C100.313 94.6667 94.6379 94.6667 83.2748 94.6667H47.1252C35.7621 94.6667 30.0866 94.6667 26.556 91.5413C23.0254 88.416 23.0254 83.392 23.0254 73.3333V41.3333Z"
      stroke="url(#paint2_linear_1501_284)"
      strokeWidth="1.5"
    />
    <path
      d="M23.0254 78.668H71.2249M107.375 78.668H95.3247"
      stroke="url(#paint3_linear_1501_284)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1501_284"
        x1="-2.23006"
        y1="25.312"
        x2="15.441"
        y2="-19.6748"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1501_284"
        x1="77.7452"
        y1="49.3346"
        x2="64.1453"
        y2="61.563"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1501_284"
        x1="21.2922"
        y1="57.3333"
        x2="59.3274"
        y2="14.5842"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1501_284"
        x1="21.2922"
        y1="79.168"
        x2="21.3044"
        y2="78.1424"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BADC2" />
        <stop offset="1" stopColor="#0AA5BE" />
      </linearGradient>
    </defs>
  </svg>
);
